module.exports = __webpack_public_path__ + "static/img/prestama.e615d63b.svg";